import script from "./host.vue?vue&type=script&setup=true&lang=js"
export * from "./host.vue?vue&type=script&setup=true&lang=js"

import "./host.vue?vue&type=style&index=0&id=74600cd6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74600cd6"]])

export default __exports__